import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import './DoubleValidationErrors.scss'
import { DetailList, TextInput } from '@tecuity/granite-ui'

export const DoubleValidationErrors = () => {
  const { doubleValidationErrors = dummyValidationErrors } = useSelector(
    (state) => state.wizard,
    shallowEqual
  )

  const parseErrorByType = (error, i) => {
    switch (error.FieldType) {
      case 'repeater':
        return (
          <div className="validation-error-row" key={i}>
            <div className="field-label">
              {error.Label} - <span className="message">{error.Message}</span>
            </div>
            <div className="repeater">
              {(error.RowErrors || []).map((rowError, j) => {
                return parseErrorByType(rowError, `${error.Label}-${j}`)
              })}
            </div>
          </div>
        )
      case 'repeaterRow':
        // ValueVerifierEntered will be a flat JSON object i.e. {"Name": "Test Name", "Address": "Test Address", "PhoneNumber": "phone"}, display as list
        return (
          <div className="validation-error-row repeater-row" key={i}>
            <DetailList
              label={`${error.Label} - ${error.Message}`}
              details={Object.entries(error.ValueVerifierEntered).map(([key, value]) => ({
                label: key,
                value,
              }))}
              topBorder
              bottomBorder
            />
          </div>
        )
      default:
        return (
          <div className="validation-error-row" key={i}>
            <TextInput
              disabled
              value={error.ValueVerifierEntered}
              label={error.Label}
              errorMessage={error.Message}
            />
          </div>
        )
    }
  }

  return (
    <div className="validation-errors">
      {doubleValidationErrors.map((error, i) => {
        return parseErrorByType(error, i)
      })}
    </div>
  )
}

const dummyValidationErrors = [
  {
    Label: 'label1',
    FieldType: 'text',
    Message: 'The input you entered did not match what the indexer entered.',
    ValueVerifierEntered: 'something',
    RowErrors: null,
  },
  {
    Label: 'label2',
    FieldType: 'address',
    Message: 'The input you entered did not match what the indexer entered.',
    ValueVerifierEntered: '123 W MAIN ST',
    RowErrors: null,
  },
  {
    Label: 'Repeater',
    FieldType: 'repeater',
    Message: 'The input you entered did not match what the indexer entered.',
    ValueVerifierEntered: null,
    RowErrors: [
      {
        Label: 'RepeaterRow1',
        FieldType: 'repeaterRow',
        Message: 'This row could not be verified',
        ValueVerifierEntered: {
          repeaterFieldLabel1: 'value 1',
          repeaterFieldLabel2: 'value 2',
        },
        RowErrors: null,
      },
      {
        Label: 'RepeaterRow2',
        FieldType: 'repeaterRow',
        Message: 'This row could not be verified',
        ValueVerifierEntered: {
          repeaterFieldLabel1: 'value 1',
          repeaterFieldLabel2: 'value 2',
        },
        RowErrors: null,
      },
    ],
  },
  {
    Label: 'Repeater',
    FieldType: 'repeater',
    Message: 'The input you entered did not match what the indexer entered.',
    ValueVerifierEntered: null,
    RowErrors: [
      {
        Label: 'RepeaterRow1',
        FieldType: 'repeaterRow',
        Message: 'This row could not be verified',
        ValueVerifierEntered: {
          repeaterFieldLabel1: 'value 1',
          repeaterFieldLabel2: 'value 2',
        },
        RowErrors: null,
      },
      {
        Label: 'RepeaterRow2',
        FieldType: 'repeaterRow',
        Message: 'This row could not be verified',
        ValueVerifierEntered: {
          repeaterFieldLabel1: 'value 1',
          repeaterFieldLabel2: 'value 2',
        },
        RowErrors: null,
      },
    ],
  },
]
